module.exports = __webpack_public_path__ + "img/weixin_pay_logo.ac49e823.png";